import { useNavigate } from 'react-router-dom';

function CTASection() {
  const navigate = useNavigate();

  return (
    <section className="py-16 md:py-24 relative overflow-hidden">
      {/* Background */}
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Abstract%20dark%20futuristic%20cityscape%20with%20neon%20blue%20lights%2C%20glowing%20network%20connections%2C%20digital%20grid%20pattern%2C%20no%20text%2C%20cinematic%20atmosphere%2C%20high%20contrast%2C%20technology%20concept%20art&width=1600&height=700&seq=cta-bg&orientation=landscape"
          alt=""
          className="w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-background-50 via-background-50/90 to-background-50/70" />
      </div>

      <div className="relative z-10 w-full px-4 md:px-8 lg:px-12">
        <div className="max-w-3xl">
          <h2 className="font-heading font-bold text-3xl md:text-5xl text-foreground-50 mb-4 leading-tight">
            Rejoignez la révolution
          </h2>
          <p className="text-lg md:text-xl text-foreground-100 mb-4 drop-shadow-[0_1px_4px_rgba(0,0,0,0.5)]">
            WorldApeiron Business, c&apos;est plus qu&apos;un annuaire.
          </p>
          <p className="text-base text-foreground-300 mb-10 max-w-xl leading-relaxed drop-shadow-[0_1px_4px_rgba(0,0,0,0.4)]">
            C&apos;est votre vitrine mondiale. Inscrivez votre entreprise dès aujourd&apos;hui et atteignez des milliers de clients. Profils vérifiés, réservations, analytics, messagerie — tout ce qu&apos;il faut pour grandir.
          </p>

          <div className="flex flex-col sm:flex-row items-start sm:items-center gap-4">
            <button
              onClick={() => navigate('/auth/register')}
              className="px-8 py-3.5 bg-primary-500 text-foreground-950 font-semibold rounded-lg hover:bg-primary-400 transition-colors whitespace-nowrap text-sm md:text-base"
            >
              Inscrire mon entreprise — Gratuit
            </button>
            <button
              onClick={() => navigate('/directory')}
              className="px-8 py-3.5 border border-foreground-400/50 text-foreground-50 font-semibold rounded-lg hover:bg-foreground-50/10 transition-colors whitespace-nowrap text-sm md:text-base"
            >
              Explorer l&apos;annuaire
            </button>
          </div>
        </div>
      </div>
    </section>
  );
}

export default CTASection;